import styled from "styled-components";
import { animated } from "react-spring";
import { MOBILE_WIDTH } from "../../constants";

export const LandingPageContainer = styled.div`
  width: 100%;
  height: calc(100vh - 90px);
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-direction: column;
  position: relative;
  z-index: 0;
`;

export const Icon = styled(animated.img)`
  width: 300px;

  @media ${MOBILE_WIDTH} {
    width: 150px;
  }
`;

export const Text = styled(animated.h2)`
  font-size: 2.5rem;
  color: #18201e;
  font-family: "Roboto", sans-serif;
  max-width: 700px;
  text-align: center;
  margin-top: 0;
  margin-bottom: 0;
  @media ${MOBILE_WIDTH} {
    font-size: 1.3rem;
    max-width: 300px;
  }
`;

export const Arrow = styled(animated.img)`
  width: 40px;
  @media ${MOBILE_WIDTH} {
    width: 25px;
  }
`;
